import React from 'react';
import { Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import authorized from '../../../authorized';

import { Grid, Row, Col, Alert } from 'react-bootstrap';
import LoginForm from './LoginForm';
import Layout from '../../ui/Layout';

const { login: { createAction: loginRequest } } = fetchDux;

export const Login = ({ user, error, location, loginRequest }) =>
  authorized({
    user,
    permissions: location.permissions
  })
    ? <Redirect to={location.from || { pathname: '/' }} />
    : <Layout route="login">
        <div>
          <a href="http://www.cftrm.com/" className="brand" />
          {error && <Alert bsStyle="danger">{error.message}</Alert>}
          <LoginForm onSubmit={values => loginRequest(values, 'login')} />
        </div>
      </Layout>;

const mapState = state => {
  const {
    result: user,
    error
  } = state.login.toJS();
  return {
    user,
    error
  };
};
const mapDispatch = dispatch => bindActionCreators({ loginRequest }, dispatch);

export default connect(mapState, mapDispatch)(Login);



// WEBPACK FOOTER //
// ./src/components/routes/login/Login.js